/* This selector encompass all the focusable dom nodes */
const TAB_SELECTOR = 'input, select, textarea, button, object, a[href], [tabindex]:not([tabindex="-1"]), area'

/* Used to show and enable a dom node and all its children from screen readers */
export const ariaShow = (target) => {
  target.removeAttribute('aria-hidden')
  target.setAttribute('tabindex', 0)

  const tabbables = target.querySelectorAll(TAB_SELECTOR)
  tabbables.forEach((tabbable) => {
    ariaShow(tabbable)
  })
}

/* Used to hide and disable a dom node and all its children from screen readers */
export const ariaHide = (target) => {
  target.setAttribute('aria-hidden', true)
  target.setAttribute('tabindex', -1)

  const tabbables = target.querySelectorAll(TAB_SELECTOR)
  tabbables.forEach((tabbable) => {
    ariaHide(tabbable)
  })
}

export const srHide = (target) => {
  target.classList.add('is-hidden')
  ariaHide(target)
}

export const srShow = (target) => {
  target.classList.remove('is-hidden')
  ariaShow(target)
}
